/*
 * サブシステム名：入金
 * 機能名：入金先登録ポップアップ
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'

import DdCustomButton from '@/components/DdCustomButton'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdIconButton = () => import('@/components/DdIconButton')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdTextBox = () => import('@/components/DdTextBox')

// 状況の値を設定
const KAKUTEI = '1'
const MATCHFLG_OK = true
const MATCHFLG_STRING_OK = '○'
export default {
  name: 'NyukinsakiMstEditDialog',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdCodeTextBox,
    DdCheckbox,
    DdIconButton,
    DdNumericBox,
    DdTextBox
  },
  props: {
    // 表示状態
    showDialog: Boolean,
    // 入金先読み取り専用判定
    readCheck: Boolean,
    Kengen: 0,
    recData: {}
  },
  data: () => ({
    id: 0,
    nyukinsakiId: 0,
    torihikisakiId: 0,
    mstNyukinsakiId: 0,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    nyukinsakiMstEditDialog: false,
    renkeiCheck: false,
    updDate: ''
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      msysKubunList: 'DDMasters/msysKubun',
      currentKaishaCode: 'users/currentKaishaCode'
    }),
    filteredTorihikisakiList () {
      console.log('■入金先検索を出力', this)
      // 入金先検索を出力
      const target = filter.dateFormatter(this.recData.impYmd)
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.torihikisakiCd === elem.nyukinTorihikisakiCd
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    isTekiyoButtonDisp () {
      // 明細から渡された値がfalse または 権限が読み取り専用以外の場合
      return this.readCheck === false && this.Kengen !== 0
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.torihikisakiId = this.recData.torihikisakiId
        this.renkeiCheck = false
      }
    }
  },
  methods: {
    initialize: function () {
      const opt = {
        loadMasters: ['msttorihikisaki', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: this.clear(),
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            rec: this.rec
          }
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.torihikisakiId = 0
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCloseClick: function (e) {
      this.clear()
      this.$emit('close')
    },
    onTekiyoBtnClick: function (e) {
      const isValid = this.validateAll(this.$refs)
      console.log('validate all ', isValid)
      if (!isValid) {
        console.log('validate error')
        return
      }

      // 取引先マスタを取得
      var torihikisaki = this.filteredTorihikisakiList.find(({ id }) => id === this.torihikisakiId)
      // 取得したデータをメイン画面に反映
      this.recData.torihikisakiId = torihikisaki.id
      this.recData.torihikisakiNm = torihikisaki.torihikisakiNm

      this.HttpClient
        .get(`/api/v1/MstNyukinsaki/FindByTorihikisakiId?id=${this.torihikisakiId}`)
        .then((data) => {
          // 入金先マスタを取得
          var nyukinsaki = data.payload

          // 返却用入金先IDをメイン画面に反映
          this.recData.nyukinsakiId = nyukinsaki.mstTorihikisakiId

          // 更新用マスタ入金先ID
          this.mstNyukinsakiId = nyukinsaki.id
          this.updDate = nyukinsaki.updDate

          // 入金先マスタに更新する項目を設定
          var rowData = {
            kozaNm: this.recData.furikomiIraininNm,
            updDate: this.updDate
          }

          // 確定に更新
          this.recData.nyukinTorikomiKbn = KAKUTEI

          // 状況の名称取得
          var state = this.msysKubunList.find((elem) => elem.kbnShuruiCd === 'KBN013' && elem.code === this.recData.nyukinTorikomiKbn && elem.kaishaCd === this.currentKaishaCode)
          this.recData.codeNm = state.codeNm
          this.recData.renkeiCheck = this.renkeiCheck
          this.recData.tekiyoFlg = true

          // 入金取込画面
          this.recData.matchFlg = MATCHFLG_OK
          this.recData.matchFlgString = MATCHFLG_STRING_OK

          // チェックボックスがオンの場合
          if (this.renkeiCheck === true) {
            // // 入金先の口座を更新
            this.UpdateKozaNm(rowData)
          } else {
            this.$emit('close', this.recData)
            this.clear(false)
          }
        })
    },
    UpdateKozaNm: function (rowData) {
      return new Promise(resolve => {
        this.HttpClient.put(`/api/v1/MstNyukinsaki/UpdateKozaNm?id=${this.mstNyukinsakiId}`, rowData)
          .then((data) => {
            this.recData.messageCd = data.summaryMessage.messageCd
            resolve()
          }).then(() => {
            this.$emit('close', this.recData)
            this.clear(false)
            resolve()
          })
      })
    }
  }
}
